import React from "react";

import { bem } from "@react-md/utils";

import AnyColor from "@mapmycustomers/shared/types/AnyColor";

import Dropdown, { DropdownProps } from "../Dropdown";

import ColorCircle from "./ColorCircleComponent";
import ColorPanel, { ColorPanelProps } from "./ColorPanel";

const block = bem("mmc-color-panel");

interface ColorDropdownProps extends Omit<DropdownProps, "overlay"> {
  colorCircleClassName?: string;
  colorPanelProps?: Omit<ColorPanelProps, "onChange" | "value">;
  disabled?: boolean;
  onChange?: (color: AnyColor) => void;
  onOpacityChange?: (opacity: number) => void;
  opacity?: number;
  placement?:
    | "bottom"
    | "bottomCenter"
    | "bottomLeft"
    | "bottomRight"
    | "top"
    | "topCenter"
    | "topLeft"
    | "topRight";
  value?: AnyColor;
}

const ColorDropdown = ({
  children,
  colorCircleClassName,
  colorPanelProps,
  disabled,
  onChange,
  onOpacityChange,
  opacity,
  placement,
  value,
  ...props
}: ColorDropdownProps) => {
  return (
    <Dropdown
      disabled={disabled}
      dropdownRender={() => (
        <ColorPanel
          className={block()}
          onChange={onChange}
          onOpacityChange={onOpacityChange}
          opacity={opacity}
          value={value}
          {...colorPanelProps}
        />
      )}
      placement={placement ?? "bottomLeft"}
      trigger={["click"]}
      {...props}
    >
      {children ?? (
        <div>
          <ColorCircle className={colorCircleClassName} disabled={disabled} value={value} />
        </div>
      )}
    </Dropdown>
  );
};

export default ColorDropdown;
